import Axios from "axios";
import {
    getSpecialFFdataListAdmin,
    ApproveSpecialFFdataAdmin,
    CencleSpecialFFdataAdmin
} from "../../../api";

import {
    SPECIAL_FF_STUDENT_DATA_LIST_ADMIN
} from "../../../mutation-types";

const state = {
    specialffstudentApplicationList: [],
};

const getters = {
    getSpetialFFstudenListAdmin(state) {
        return state.specialffstudentApplicationList;
    },
};

const mutations = {
    [SPECIAL_FF_STUDENT_DATA_LIST_ADMIN](state, data) {
        state.specialffstudentApplicationList = data;
    },
};

const actions = {
    getSpecialFFStudentListAdmin({ commit }, schema) {
        let data = schema;
        return new Promise(function (resolve, reject) {
            commit("SET_LOADING", { color: "primary" });
            Axios.get(getSpecialFFdataListAdmin, { params: data })
                .then(function (response) {
                    console.log(response);
                    let result = response.data.data;
                    commit("SPECIAL_FF_STUDENT_DATA_LIST_ADMIN", result);
                    resolve(response.data);
                    commit("UNSET_LOADING");
                })
                .catch(function (error) {
                    commit("SET_SNACKBAR", {
                        msg: error.response.data.message,
                        color: "red"
                    });
                    commit("UNSET_LOADING");
                    //reject();
                });
        });
    },


    ApproveSpecialFFApplicationAdmin({ commit }, id) {
        return new Promise((resolve, reject) => {
            commit("SET_LOADING", { color: "primary" });
            Axios.get(`${ApproveSpecialFFdataAdmin}/${id}`)
                .then(response => {
                    console.log(response);
                    const result = response.data;
                    commit("SET_SNACKBAR", {
                        msg:
                            (result && result.data && result.data.message) ||
                            (result && result.message) ||
                            "Operation successful",
                        color: "green"
                    });
                    resolve(result);
                })
                .catch(error => {
                    commit("SET_SNACKBAR", {
                        msg:
                            (error.response &&
                                error.response.data &&
                                error.response.data.message) ||
                            "An error occurred",
                        color: "red"
                    });
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },

    cancleSpecialFFApplicationAdmin({ commit }, id) {
        return new Promise((resolve, reject) => {
            commit("SET_LOADING", { color: "primary" });
            Axios.get(`${CencleSpecialFFdataAdmin}/${id}`)
                .then(response => {
                    console.log(response);
                    const result = response.data;
                    commit("SET_SNACKBAR", {
                        msg:
                            (result && result.data && result.data.message) ||
                            (result && result.message) ||
                            "Operation successful",
                        color: "green"
                    });
                    resolve(result);
                })
                .catch(error => {
                    commit("SET_SNACKBAR", {
                        msg:
                            (error.response &&
                                error.response.data &&
                                error.response.data.message) ||
                            "An error occurred",
                        color: "red"
                    });
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },


};


export default {
    state,
    getters,
    actions,
    mutations
};
